import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {SavedFilterSortType} from 'nutshell-graphql-types';
import type {
    GetEmailMarketingSavedFilters as GetEmailMarketingSavedFiltersQuery,
    GetEmailMarketingSavedFiltersVariables as GetEmailMarketingSavedFiltersQueryVariables,
    GetEmailMarketingSavedFilters_emailMarketingSavedFilters as SavedFilter,
} from 'nutshell-graphql-types';

import GET_EMAIL_MARKETING_SAVED_FILTERS from '../queries/get-email-marketing-saved-filters.graphql';

export const useGetEmailMarketingSavedFilters = (
    sort?: SavedFilterSortType
): {
    emailMarketingSavedFilters: Array<SavedFilter>;
    error: string | null | undefined;
    isLoading: boolean;
} => {
    const {data, error, loading} = useQuery<
        GetEmailMarketingSavedFiltersQuery,
        GetEmailMarketingSavedFiltersQueryVariables
    >(GET_EMAIL_MARKETING_SAVED_FILTERS, {
        variables: {
            sort: sort || null,
        },
        fetchPolicy: 'cache-and-network',
    });

    const emailMarketingSavedFilters = data ? data.emailMarketingSavedFilters : null;

    return {
        emailMarketingSavedFilters: emailMarketingSavedFilters || [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
